const stores = [
  {
    id: 'store-AT',
    code: 'AT',
    name: 'Österreich',
    url: 'https://www.stubhub.co.at',
    domain: 'stubhub.co.at',
  },
  {
    id: 'store-CZ',
    code: 'CZ',
    name: 'Česká republika',
    url: 'https://www.stubhub.cz',
    domain: 'stubhub.cz',
  },
  {
    id: 'store-GR',
    code: 'GR',
    name: 'Ελλάδα',
    url: 'https://www.stubhub.gr',
    domain: 'stubhub.gr',
  },
  {
    id: 'store-BE',
    code: 'BE',
    name: 'België',
    url: 'https://www.stubhub.be',
    domain: 'stubhub.be',
  },
  {
    id: 'store-fr.BE',
    code: 'BE',
    name: 'Belgique',
    url: 'https://www.stubhub.be/fr',
    domain: 'stubhub.be/fr',
  },
  {
    id: 'store-DK',
    code: 'DK',
    name: 'Danmark',
    url: 'https://www.stubhub.dk',
    domain: 'stubhub.dk',
  },
  {
    id: 'store-DE',
    code: 'DE',
    name: 'Deutschland',
    url: 'https://www.stubhub.de',
    domain: 'stubhub.de',
  },
  {
    id: 'store-ES',
    code: 'ES',
    name: 'España',
    url: 'https://www.stubhub.es',
    domain: 'stubhub.es',
  },
  {
    id: 'store-FR',
    code: 'FR',
    name: 'France',
    url: 'https://www.stubhub.fr',
    domain: 'stubhub.fr',
  },
  {
    id: 'store-IE',
    code: 'IE',
    name: 'Ireland',
    url: 'https://www.stubhub.ie',
    domain: 'stubhub.ie',
  },
  {
    id: 'store-IT',
    code: 'IT',
    name: 'Italia',
    url: 'https://www.stubhub.it',
    domain: 'stubhub.it',
  },
  {
    id: 'store-LU',
    code: 'LU',
    name: 'Luxembourg',
    url: 'https://www.stubhub.lu',
    domain: 'stubhub.lu',
  },
  {
    id: 'store-de.LU',
    code: 'LU',
    name: 'Luxemburg',
    url: 'https://www.stubhub.lu/de',
    domain: 'stubhub.lu/de',
  },
  {
    id: 'store-MX',
    code: 'MX',
    name: 'México',
    url: 'https://www.stubhub.mx',
    domain: 'stubhub.mx',
  },
  {
    id: 'store-NL',
    code: 'NL',
    name: 'Nederland',
    url: 'https://www.stubhub.nl',
    domain: 'stubhub.nl',
  },
  {
    id: 'store-PL',
    code: 'PL',
    name: 'Polska',
    url: 'https://www.stubhub.pl',
    domain: 'stubhub.pl',
  },
  {
    id: 'store-PT',
    code: 'PT',
    name: 'Portugal',
    url: 'https://www.stubhub.pt',
    domain: 'stubhub.pt',
  },
  {
    id: 'store-FI',
    code: 'FI',
    name: 'Suomi',
    url: 'https://www.stubhub.fi',
    domain: 'stubhub.fi',
  },
  {
    id: 'store-SE',
    code: 'SE',
    name: 'Sverige',
    url: 'https://www.stubhub.se',
    domain: 'stubhub.se',
  },
  {
    id: 'store-GB',
    code: 'GB',
    name: 'United Kingdom',
    url: 'https://www.stubhub.co.uk',
    domain: 'stubhub.co.uk',
  },
];

export default stores;
